import { isValidPhoneNumber } from 'libphonenumber-js';
export const validatePhoneNumber = (phoneNumber, countryCode) => {
  if (!phoneNumber) {
    return false;
  }
  return isValidPhoneNumber(phoneNumber, countryCode);
};